export default "__VITE_PUBLIC_ASSET__c61386c1__"